import { ReactiveWithMutableValue1h1r6ig7acce5 as ReactiveWithMutableValue } from './coreInterfaces.mjs';
import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Signal1973xs1vkmdcb as Signal } from './signals.mjs';
import { MutableRememberyv35kz5kmml7 as MutableRemember } from './MutableRemember.mjs';
import { awaitOnce2ui7qqi9bvdeq as awaitOnce } from '../context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { remembery2gxxk5pa2qe as remember } from './Remember.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DraftClass;
function Draft() {
  if (DraftClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Draft', VOID, VOID, [ReactiveWithMutableValue()], [0, 1]);
    DraftClass = $;
  }
  return DraftClass;
}
function Draft_0(initialValue) {
  return BaseDraft().lak(Signal().hak(initialValue));
}
function Draft_1(initialValue) {
  return BaseDraft().lak(MutableRemember().tak(VOID, true, VOID, VOID, initialValue));
}
function Draft_2(published) {
  return BaseDraft().lak(published);
}
function *_generator_publish__pkz857($this, $completion) {
  var tmp = awaitOnce($this.jak_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.iak_1.iah(tmp, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  $this.jak_1.d52();
  var tmp_1 = awaitOnce($this, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1;
}
function *_generator_set__cb7isu($this, value, $completion) {
  var tmp = $this.jak_1.iah(value, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var BaseDraftClass;
function BaseDraft() {
  if (BaseDraftClass === VOID) {
    class $ {
      static uak(published, buffer) {
        var $this = createThis(this);
        $this.iak_1 = published;
        $this.jak_1 = buffer;
        var tmp = $this;
        tmp.kak_1 = remember(VOID, VOID, VOID, ($this$remember) => !equals($this$remember.daj($this.jak_1), $this$remember.daj($this.iak_1)));
        return $this;
      }
      aak() {
        return this.iak_1;
      }
      static lak(published) {
        return this.uak(published, MutableRemember().tak(false, VOID, VOID, VOID, ($this$MutableRemember) => $this$MutableRemember.daj(published)));
      }
      cak() {
        return this.kak_1;
      }
      bak($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_publish__pkz857.bind(VOID, this), $completion);
      }
      nai() {
        this.jak_1.d52();
      }
      vak(get, set) {
        return this.jak_1.vak(get, set);
      }
      dak(get, modify) {
        return this.jak_1.dak(get, modify);
      }
      sah() {
        return this.jak_1.sah();
      }
      vah(listener) {
        return this.jak_1.vah(listener);
      }
      kaj() {
        return this.jak_1.kaj();
      }
      iah(value, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_set__cb7isu.bind(VOID, this, value), $completion);
      }
      eak(value) {
        this.jak_1.eak(value);
      }
    }
    initMetadataForClass($, 'BaseDraft', VOID, VOID, [Draft(), ReactiveWithMutableValue()], [0, 1]);
    BaseDraftClass = $;
  }
  return BaseDraftClass;
}
//region block: exports
export {
  Draft_0 as Draft43syxm8fng0j,
  Draft_1 as Draftj5auffrm1u2b,
  Draft_2 as Draftazcheef5x425,
  Draft as Draft3jz09icer2h2u,
};
//endregion

//# sourceMappingURL=Draft.mjs.map
